import * as React from 'react';

const ICON = `M12.9522 20.9046C15.073 19.4935 20 15.7087 20 11C20 6.58172 16.4183 3 12 3C7.58172 3 4 6.58172 4 11C4 15.7087 8.92699 19.4935 11.0478 20.9046C11.6294 21.2915 12.3706 21.2915 12.9522 20.9046ZM12 7.75C10.2051 7.75 8.75 9.20507 8.75 11C8.75 12.7949 10.2051 14.25 12 14.25C13.7949 14.25 15.25 12.7949 15.25 11C15.25 9.20507 13.7949 7.75 12 7.75Z" fill="#323232"/>
<path d="M20 11C20 13.2685 18.8565 15.3225 17.4341 17C15.9045 18.8039 14.0525 20.1724 12.9533 20.9039C12.3717 21.2908 11.6283 21.2908 11.0467 20.9039C9.94752 20.1724 8.09548 18.8039 6.56591 17C5.14353 15.3225 4 13.2685 4 11C4 6.58172 7.58172 3 12 3C16.4183 3 20 6.58172 20 11Z" stroke="#323232" stroke-width="2"/>
<path d="M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z`;

const pinStyle = {
    cursor: 'pointer',
    fill: '#d00',
    stroke: 'none'
};

function Pin({ size = 24 }) {
    return (
        <svg height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={pinStyle}>
            <path opacity="1" fillRule="evenodd" clipRule="evenodd" d={ICON} strokeWidth="1" />
        </svg>
    );
}

export default React.memo(Pin);